
export default (state = 'cardView', action) => {
    if (action.type === 'CHANGE_VIEW') {
        return action.payload;
    }

    return state;
}